exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "editor .form-control{height:auto;padding:15px 0 0;background:none;border:none;font-size:inherit;line-height:inherit;color:inherit;box-shadow:none}editor .ta-resizer-handle-overlay{display:none!important}editor div[contenteditable=true]{outline:none}editor .btn.disabled,editor .btn[disabled],editor fieldset[disabled] .btn{opacity:.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/editor/editor.scss
// module id = 455
// module chunks = 0